import { FC, ReactNode } from 'react';

export interface StepListProps {
  steps: ReactNode[];
  className?: string;
}

/**
 * StepList — Widget do Design System para instruções sequenciais e tutoriais.
 * Encapsula numeração circular, bordas de superfície e tipografia semântica.
 */
export const StepList: FC<StepListProps> = ({ steps, className = '' }) => {
  return (
    <ol className={`space-y-3 text-xs text-content-muted ${className}`}>
      {steps.map((step, index) => (
        <li key={index} className="flex items-start gap-3">
          <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 select-none items-center justify-center rounded-full border border-surface-border bg-surface-subtle text-micro font-semibold text-content-main">
            {index + 1}
          </span>
          <div className="flex-1 leading-relaxed">{step}</div>
        </li>
      ))}
    </ol>
  );
};
